export default "__VITE_ASSET__BBdWy8Ns__"